import axios from 'axios';
import { toast } from 'react-toastify';

export const instance = axios.create({
   baseURL: 'http://41.186.24.68:20800/api/v1',
   timeout: 10000000,
   headers: {
      'Content-Type': 'application/json',
   },
});

instance.defaults.headers.common['Authorization'] = 'AUTH_TOKEN';
instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.interceptors.response.use(
   function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
   },
   function (error) {
      if (error.message.includes('Network Error') || !error.response) {
         toast('Network error - make sure API is running', {
            autoClose: true,
         });
      } else {
         // data
         const { status, config } = error.response;
         if (status === 404) {
            toast('Resource Not found !!!', { autoClose: true });
         }
         if (status === 400 && config.method === 'get') {
            toast('Resource Not found !!!', { autoClose: true });
         }
         if (status === 500) {
            toast('Server error - check the terminal for more info', {
               autoClose: true,
            });
         }
      }
      return Promise.reject(error);
   }
);
